import type { Role, RoleDef } from '@/types/domain';

/** What each role can do — drives the access-management panel + RBAC. */
export const roleDefs: Record<Role, RoleDef> = {
  staff: {
    role: 'staff',
    label: { en: 'User', th: 'ผู้ใช้งาน' },
    tone: 'gray',
    perms: ['Enroll in courses', 'Take tests', 'Earn certificates'],
  },
  instructor: {
    role: 'instructor',
    label: { en: 'Instructor', th: 'ผู้สอน' },
    tone: 'slate',
    perms: ['Build courses & tests', 'Manage attendance', 'Approve certificates'],
  },
  admin: {
    role: 'admin',
    label: { en: 'Admin', th: 'ผู้ดูแล' },
    tone: 'sage',
    perms: ['Approve sign-ups', 'Manage courses & org', 'Verify certificates', 'View reports'],
  },
  superadmin: {
    role: 'superadmin',
    label: { en: 'Super Admin', th: 'ผู้ดูแลระบบสูงสุด' },
    tone: 'spark',
    perms: ['Everything Admin can', 'Manage users & roles', 'Assign admins', 'System settings'],
  },
};
